import * as Yup from 'yup';

const validationSchema = (t) =>
  Yup.object().shape({
    invoices: Yup.array()
      .min(1, t('SANTANDER_REPORTS.INVOICE_REQUIRED'))
      .of(
        Yup.object()
          .nullable()
          .required(t('SANTANDER_REPORTS.INVOICE_REQUIRED'))
          .shape({
            amountToPay: Yup.number()
              .required(t('SANTANDER_REPORTS.INVOICE_REQUIRED'))
              .moreThan(0, t('SCHEMA_ERRORS.VALUE_GREATER_THAN_ZERO'))
              .when('amountIvaIncluded', (amountIvaIncluded, schema) =>
                schema.max(
                  amountIvaIncluded,
                  t(
                    'SCHEMA_ERRORS.AMOUNT_TO_PAY_MUST_BE_LESS_THAN_OR_EQUAL_TO_AMOUNT_IVA_INCLUDED'
                  )
                )
              ),

            amountIvaIncluded: Yup.number()
              .required(t('SANTANDER_REPORTS.INVOICE_REQUIRED'))
          })
      )
  });

export default validationSchema;
